module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "sign-up-illustration.8b94eef3.png" + "?" + Date.now();